import * as React from "react";
import MuiChip from "@mui/material/Chip";

export default function Chip({ label, handleClick, ...restProps }) {
    return <MuiChip label={label} onClick={handleClick} {...restProps} />;
}

